import _ from "lodash";
import { getMessagingV2ReduxState } from "./MessagingModule";

export const getMessageStatus = ({ state, messageId }) =>
  _.get(getMessagingV2ReduxState(state), ["messageStatus", messageId]);
